export default "__VITE_ASSET__Bd2uHG6E__"